export default __webpack_public_path__ + "images/0xd6df932a45c0f255f85145f286ea0b292b21c90b.png";